<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <CandidatesList />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import CandidatesList from '@/components/Admin/Candidates/CandidatesList';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Sidebar,
    TopNavbar,
    CandidatesList,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions(['retrieveUserProfile']),
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.retrieveUserProfile();
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

#activities,
#emails {
  h6 {
    font-size: 18px;
    font-family: $font-family-sans-serif;
  }

  .activities-media li {
    border-radius: 0 !important;
    border: 0;
  }

  .activities-media li:nth-child(odd) {
    border-left: 5px solid #f05a00;
    background-color: #f1f1f3;
  }

  .activities-media li:nth-child(even) {
    border-left: 5px solid #747674;
  }

  .activities-name {
    font-family: Lato;
    color: $color-base-blue;
    letter-spacing: 0.9px;
    margin: 0;
  }

  .activities-status-color {
    color: #f05a00;
  }
}
</style>
